var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_124_9732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 11.2623,
    height: 11.2623,
    rx: 5.63115,
    fill: "#B6DDFF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.20201,
    y: 1.20201,
    width: 10.8583,
    height: 10.8583,
    rx: 5.42914,
    stroke: "#2070B8",
    strokeWidth: 0.404022,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63143 10.7375C9.89914 10.7375 11.7375 8.89914 11.7375 6.63143C11.7375 4.36373 9.89914 2.52539 7.63143 2.52539C5.36373 2.52539 3.52539 4.36373 3.52539 6.63143C3.52539 8.89914 5.36373 10.7375 7.63143 10.7375Z",
    fill: "#2070B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.2207,
    y: 5.81006,
    width: 0.821209,
    height: 2.87423,
    rx: 0.410605,
    fill: "#3579C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.2207,
    y: 4.57861,
    width: 0.821209,
    height: 0.821209,
    rx: 0.410604,
    fill: "#2070B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_124_9732",
    x: 0.38391,
    y: 0.191955,
    width: 14.4949,
    height: 14.4944,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.808045
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.808045
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_9732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_124_9732",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.1089f387c3aa27daa4e6cce73e3374e0.svg";
export { ForwardRef as ReactComponent };